import angular from 'angular';
import uiRouter from 'angular-ui-router';
import navbarComponent from './navbar.component';
import helpCentreService from '../../services/helpCentre.service';

const navbarModule = angular.module('navbar', [
    uiRouter,
    helpCentreService
  ])
  .component('navbar', navbarComponent)
  .name;

export default navbarModule;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.js